/**
 * @module セキュリティスイッチ部共通コンポーネント
 */
export default {
  name: 'SecuritySwitch',
  props: {
    status: {
      type: String,
      default: '',
      require: false,
    },
    left: {
      type: String,
      default: 'ALSOK',
      require: false,
    },
    right: {
      type: String,
      default: 'セルフ',
      require: false,
    },
    securityOperation: {
      type: Boolean,
      default: false,
      require: false,
    },
    existsSecurityArea: {
      type: Boolean,
      default: false,
      require: false,
    },
    // FIXME: 悪手な気がするから動的対応でスマートにしてください
    topPage: {
      type: Boolean,
      default: false,
      require: false,
    },
    callSaveAgreementDialog: {
      type: Function,
      default: () => {},
    },
    propTabNumber: {
      type: Number,
      default: 0,
      require: false,
    },
    propAbsenceSwitch: {
      type: Boolean,
      default: false,
      require: false,
    },
    propAthomeSwitch: {
      type: Boolean,
      default: false,
      require: false,
    },
    dontSelectFlag: {
      type: Boolean,
      default: false,
      require: false,
    },
    changeSecurity: {
      type: Boolean,
      default: false,
      require: false,
    },
    multipleChoice: {
      type: Boolean,
      default: false,
      require: false,
    },
    reset: {
      type: Boolean,
      default: false,
      require: false,
    },
  },
  data(vm) {
    return {
      switch3: false,
      disableFlag: false,
      dialog: false,
      yes: vm.$vuetify.lang.t('$vuetify.FECU07.はいボタン'),
      no: vm.$vuetify.lang.t('$vuetify.FECU07.いいえボタン'),
      confirm: vm.$vuetify.lang.t('$vuetify.FECU07.確認'),
      registConfirm: vm.$vuetify.lang.t('$vuetify.FECU07.入力された内容で登録します'),
      outside: vm.$vuetify.lang.t('$vuetify.FECU07.外出'),
      inside: vm.$vuetify.lang.t('$vuetify.FECU07.在宅'),
      lift: vm.$vuetify.lang.t('$vuetify.FECU07.解除'),
      snackbar: false,
      text: vm.$vuetify.lang.t('$vuetify.FECU07.選択できません'),
      mode: '',
      tabNumber: 0,
      absenceSwitch: false,
      athomeSwitch: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        yes: vm.$vuetify.lang.t('$vuetify.FECU07.はいボタン'),
        no: vm.$vuetify.lang.t('$vuetify.FECU07.いいえボタン'),
        confirm: vm.$vuetify.lang.t('$vuetify.FECU07.確認'),
        registConfirm: vm.$vuetify.lang.t('$vuetify.FECU07.入力された内容で登録します'),
        outside: vm.$vuetify.lang.t('$vuetify.FECU07.外出'),
        inside: vm.$vuetify.lang.t('$vuetify.FECU07.在宅'),
        lift: vm.$vuetify.lang.t('$vuetify.FECU07.解除'),
        self: vm.$vuetify.lang.t('$vuetify.FECU07.セルフ'),
        alsok: vm.$vuetify.lang.t('$vuetify.FECU07.オンライン'),
        text: vm.$vuetify.lang.t('$vuetify.FECU07.選択できません'),
        mode: this.multipleChoice
          ? vm.$vuetify.lang.t('$vuetify.FECU07.複数選択中')
          : this.getSecurityStatusMessage(this.status),
      };
    },
  },
  watch: {
    propTabNumber(newVal) {
      this.tabNumber = newVal;
    },
    propAbsenceSwitch(newVal) {
      this.absenceSwitch = newVal;
    },
    propAthomeSwitch(newVal) {
      this.athomeSwitch = newVal;
    },
    reset() {
      if (this.tabNumber != this.propTabNumber) {
        this.tabNumber = this.propTabNumber;
      }
      if (this.absenceSwitch != this.propAbsenceSwitch) {
        this.absenceSwitch = this.propAbsenceSwitch;
      }
      if (this.athomeSwitch != this.propAthomeSwitch) {
        this.athomeSwitch = this.propAthomeSwitch;
      }
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * タブ選択処理
     * @param {number} num
     */
    tabSelect: function (num) {
      this.tabNumber = num;
    },
    /**
     * 外出スイッチ切り替え
     */
    absenceSwitchSelect: function () {
      if (!this.dontSelectFlag) {
        this.absenceSwitch = !this.absenceSwitch;
        this.athomeSwitch = this.absenceSwitch;
      } else {
        this.snackbar = true;
      }
    },
    /**
     * 在宅スイッチ切り替え
     */
    athomeSwitchSelect: function () {
      if (!this.dontSelectFlag) {
        this.athomeSwitch = !this.athomeSwitch;
        this.absenceSwitch = this.athomeSwitch;
      } else {
        this.snackbar = true;
      }
    },
    switch3Select: function () {
      this.switch3 = !this.switch3;
    },
    toggleDialog: function () {
      this.dialog = !this.dialog;
    },
    /**
     * セキュリティステータス取得
     * @returns securityStatus セキュリティステータス
     */
    getSecurityStatus: function () {
      let securityStatus = 'F';
      switch (this.tabNumber) {
        case 0:
          if (this.absenceSwitch) {
            securityStatus = 'N';
          } else {
            securityStatus = 'S';
          }
          break;
        case 1:
          if (this.athomeSwitch) {
            securityStatus = 'M';
          } else {
            securityStatus = 'L';
          }
          break;
        case 2:
          securityStatus = 'F';
          break;
      }
      return securityStatus;
    },
    /**
     * セキュリティステータスメッセージ取得
     * @param {String} status
     * @returns string セキュリティステータスメッセージ
     */
    getSecurityStatusMessage: function (status) {
      switch (status) {
        case 'N':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.外出ALSOK警備中');
        case 'M':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.在宅ALSOK警備中');
        case 'S':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.外出セルフ警備中');
        case 'L':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.在宅セルフ警備中');
        case 'F':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.警備解除中');
        case 'P':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.ユーザ点検');
        default:
          return '';
      }
    },
  },
};
